import { createReducer } from 'deox';
import { FeatureItems, OptionFilter } from '@/types';
import { clearFeaturesAction, getFeatureItemsActions } from '@/redux/actions/service-directory/feature-item';

export interface FeatureItemsState {
  data?: FeatureItems;
  categories: {
    api?: { [checkbox: string]: OptionFilter };
    app?: { [checkbox: string]: OptionFilter };
    entity?: { [checkbox: string]: OptionFilter };
  };
}

const initialState: FeatureItemsState = {
  data: undefined,
  categories: {
    api: undefined,
    app: undefined,
    entity: undefined,
  },
};

const featureItemsReducer = createReducer(initialState, (handleAction) => [
  handleAction(getFeatureItemsActions.success, (state, { payload }) => {
    return {
      ...state,
      data: payload.data,
      categories: {
        api: payload.apiFilterOption,
        app: payload.appFilterOption,
        entity: payload.entityFilterOptions,
      },
    };
  }),
  handleAction(clearFeaturesAction.request, (state) => {
    return {
      ...state,
      data: undefined,
      categories: {
        api: undefined,
        app: undefined,
        entity: undefined,
      },
    };
  }),
]);

export default featureItemsReducer;
